<script>
/**
 * filterTags -> applied filter values
 */
import moment from 'moment';
import { isNil } from 'lodash';

const SecFilterMixin = {
  data() {
    return {
      filterTags: [],
      selectedDateFilter: 'creation',
      lists : [0, 7],
      ignoreList :[7]
    };
  },
  computed: {
    localStorageTagName() {
      return this.localStorageName || this.$route.name;
    },
  },
  methods: {
    findByCategory(category) {
      const filterTag =  this.filterTags.find(val => val.category === category);
      if (filterTag && filterTag.category === 'Date') {
        return filterTag;
      } else {
        return filterTag && filterTag.selected;
      }
    },
    clearAllGA(index1, index2) {
      if(this.hasGACapture) {
        this.callGA('Click', `${this.filterConstant[index1][index2].category} filter cross button`);
      }
    },
    updateDate(data, label) {
      this[label] = data;
      const maxDaysAllowed = 90;
      if(label === 'startDate' && maxDaysAllowed) {
        const endDate = this.endDate;
        const startDate = this.startDate;
        const maxDate = moment(data).add(maxDaysAllowed - 1,'days').toString();
        this.maxDate = maxDate;
        if(moment(endDate).diff(moment(maxDate),'seconds') > 0) {
          //setting the end date before startDate clears the end date selection
          this.endDate =
            moment(startDate).subtract(2,'days').toString();;
        }
      }
      if(label === 'endDate' && maxDaysAllowed && this.endDate) {
        this.maxDate = null;
      }
    },
    updateRadio(index1, index2) {
      this.filterConstant[index1][index2].startDate = null;
      this.filterConstant[index1][index2].endDate = null;
    },
    updateOption(index1, index2, data, type = null, selectedDateFilter = null) {
      if (selectedDateFilter) {
        this.selectedDateFilter = selectedDateFilter;
      }
      if(this.hasGACapture) {
        this.callGA('Change', `${this.filterConstant[index1][index2].category} filter`);
      }
      if(['List','MultiSelectList','GroupList', 'MultiSelectGroup'].includes(this.filterConstant[index1][index2].type)) {
        this.filterConstant[index1][index2].selected = data;
        if (type && type.queryParamString === 'depot_id' && type.type !== 'MultiSelectList') {
        const gateIndex = this.filterConstant[index1].findIndex(item=> item.queryParamString === 'gate_id');
        if (gateIndex !== -1) {
          const gates = [...data.gates];
          gates.unshift(this.allGates);
            this.filterConstant[index1][gateIndex].list = gates || [];
            this.filterConstant[index1][gateIndex].selected = { id: -1,
        name: 'All Gates' };
        }
      }
      if (type && (type.queryParamString === 'depot_ids' || type.queryParamString === 'depot_id') && type.type === 'MultiSelectList') {
        const gateIndex = this.filterConstant[index1].findIndex(item=> (item.queryParamString === 'gate_ids' || item.queryParamString === 'gate_id'));
        if (gateIndex !== -1) {
          if (data.length === 1) {
            (type.queryParamString === 'depot_id' && type.type === 'MultiSelectList')? data[0].gates.unshift({ id: -1,
        name: 'All Gates' }) : {};
            this.filterConstant[index1][gateIndex].list = data[0].gates || [];
            this.filterConstant[index1][gateIndex].selected = (type.queryParamString === 'depot_id' && type.type === 'MultiSelectList') ? data[0].gates[0] || [] : data[0].gates;
          } else {
            this.filterConstant[index1][gateIndex].list = (type.queryParamString === 'depot_id' && type.type === 'MultiSelectList') ? [{ id: -1, name: 'All Gates' }] : [];
            this.filterConstant[index1][gateIndex].selected = (type.queryParamString === 'depot_id' && type.type === 'MultiSelectList') ? { id: -1, name: 'All Gates' } : [];
          }
        }
      }
      if (type && (type.queryParamString === 'depot_ids' || type.queryParamString === 'depot_id') && type.type === 'MultiSelectGroup') {
            const associatedDepots = (this.depots && this.depots.filter(depot => data.includes(depot.id)) || this.depotsList.filter(depot => data.includes(depot.id)));
            const otherDepots = this.otherDepots.filter(depot => data.includes(depot.id));
            this.filterConstant[index1][index2].selected = [...associatedDepots, ...otherDepots];   
            const selectedDepots = this.filterConstant[index1][index2].selected;
            const gateIndex = this.filterConstant[index1].findIndex(item=> (item.queryParamString === 'gate_ids' || item.queryParamString === 'gate_id'));
            if(gateIndex !== -1) {
                if(selectedDepots.length  === 1)   {
                  this.filterConstant[index1][gateIndex].list = selectedDepots[0].gates || [];
                  this.filterConstant[index1][gateIndex].selected = selectedDepots[0].gates || [];
                } else {
                  this.filterConstant[index1][gateIndex].list = [] ;
                  this.filterConstant[index1][gateIndex].selected = [] ;
                }
            } 
       }
        const { depots } = data;
        if(depots && depots.length) {
          const clientId = data.id;
          const depotIndex = this.filterConstant[index1].findIndex(depot=> depot.queryParamString === 'depot_id');
          if(depotIndex !== -1) {
              this.filterConstant[index1][depotIndex].list = depots || [];
               this.filterConstant[index1][depotIndex].selected = depots[0];
          }
        }
        if (type && type.queryParamString === 'depot_id') {
          if (this.isIndentListView) {
            this.processMaterialCategories(data, type);
          }
        }
      } else if (this.filterConstant[index1][index2].type === 'Date'){
        this.filterConstant[index1][index2][type] = data.toString();
        const maxDaysAllowed = this.filterConstant[index1][index2].maxDays;
        if(type === 'startDate' && maxDaysAllowed) {
          const endDate = this.filterConstant[index1][index2].endDate;
          const startDate = this.filterConstant[index1][index2].startDate;
          const maxDate = moment(data).add(maxDaysAllowed - 1,'days').toString();
          this.filterConstant[index1][index2].maxDate = maxDate;
          if(moment(endDate).diff(moment(maxDate),'seconds') > 0) {
            //setting the end date before startDate clears the end date selection
            this.filterConstant[index1][index2].endDate =
              moment(startDate).subtract(2,'days').toString();
          }
        }
        if(type === 'endDate' && maxDaysAllowed && this.filterConstant[index1][index2].endDate) {
          this.filterConstant[index1][index2].maxDate = null;
        }
      } else if (this.filterConstant[index1][index2].type === 'DatePicker'){
        this.filterConstant[index1][index2][type] = data.toString();
        const maxDaysAllowed = this.filterConstant[index1][index2].maxDays;
        if(type === 'startDate' && maxDaysAllowed) {
          const endDate = this.filterConstant[index1][index2].endDate;
          const startDate = this.filterConstant[index1][index2].startDate;
          const maxDate = moment(data).add(maxDaysAllowed - 1,'days').toString();
          this.filterConstant[index1][index2].maxDate = maxDate;
          if(moment(endDate).diff(moment(maxDate),'seconds') > 0) {
            //setting the end date before startDate clears the end date selection
            this.filterConstant[index1][index2].endDate =
              moment(startDate).subtract(2,'days').toString();
          }
        }
        if(type === 'endDate' && maxDaysAllowed && this.filterConstant[index1][index2].endDate) {
          this.filterConstant[index1][index2].maxDate = null;
        }
      } else if (this.filterConstant[index1][index2].type === 'SingleDate') {
        this.filterConstant[index1][index2].selected = data && data.toISOString();
      } else if (this.filterConstant[index1][index2].type === 'Toggle') {
        this.filterConstant[index1][index2].selected = data;
      }
    },

    clearDate(index1, index2,type) {
      if(type ==='DatePicker'){
        const statusGroupIndex = this.filterConstant.findIndex(constant => constant.some(item => item.queryParamString === 'status'));
        if (statusGroupIndex !== -1) {
          const statusIndex = this.filterConstant[statusGroupIndex].findIndex(constant => constant.queryParamString === 'status');
          const enableObj  = this.filterConstant[statusGroupIndex][statusIndex].list.map(order => { if(this.lists.includes(order.id))  order.$isDisabled = false; return order});
        }
      }
      this.filterConstant[index1][index2].startDate = null;
      this.filterConstant[index1][index2].endDate = null;
    },

    clearSingleDate(index1, index2) {
      this.filterConstant[index1][index2].selected = null;
    },

    constructFilterPayload() {
      let filter = {};
      const params = this.filterTags;
      for (var i = 0; i < params.length; i++) {
        let param = params[i];
        if(param.type === 'List') {
          if ((param.queryParamString === 'order_type' || param.queryParamString === 'status')
            && param.selected && param.selected[param.idLabel] >= 0) {
              if (param.queryParamString === 'status' && param.selected.hasOwnProperty('value') && param.selected.dataType && param.selected.dataType == 'boolean') {
                filter[param.queryParamString] = param.selected.value;
              } else {
                filter[param.queryParamString] = param.selected[param.idLabel];
              }
          } else if(param.queryParamString === 'shipper_id'){
            const clientId = param.selected[param.idLabel];
            filter[param.queryParamString] = clientId;
          } else if(param.allowZeroId && param.selected && ![-1].includes(param.selected[param.idLabel])) {
            filter[param.queryParamString] = param.selected[param.idLabel];
          } else if(param.selected && ![0,-1].includes(param.selected[param.idLabel])){
            filter[param.queryParamString] = param.selected[param.idLabel];
          }
        } else if(param.type === 'MultiSelectList') {
          // TODO handle empty params incase of input field
          // if(!param.optional && !param.selected.length < 0) {
          //   return false;
          // } else
          if(param.selected && param.selected.length > 0){
              filter[param.queryParamString] = param.selected.filter(val => val[param.idLabel])
              .map(val => val[param.idLabel]).join(',');
          }
        } else if(param.type === 'Date' && param.startDate && param.endDate) {
          filter[param.start_date_label] =
            this.$moment(param.startDate).startOf('day').toISOString();
          filter[param.end_date_label] = this.$moment(param.endDate).endOf('day').toISOString();
        } else if(param.type === 'DatePicker' && param.startDate && param.endDate && this.selectedDateFilter) {
          filter[`${this.selectedDateFilter}_${param.start_date_label}_date`] =
            this.$moment(param.startDate).startOf('day').toISOString();
          filter[`${this.selectedDateFilter}_${param.end_date_label}_date`] = this.$moment(param.endDate).endOf('day').toISOString();
        } else if (param.type === 'SingleDate') {
          filter[param.queryParamString] = param.selected;
        } else if (param.type === 'GroupList' && param.selected) {
          if (!isNil(param.selected[param.idLabel]) && param.selected[param.idLabel] !== -1) {
            filter[param.queryParamString] = param.selected[param.idLabel];
          } else if(!isNil(param.selected[param.parentIdLabel]) && param.selected[param.parentIdLabel] !== -1){
            filter[param.parentQueryParamString] = param.selected[param.parentIdLabel];
          }
        } else if(param.type === 'MultiSelectGroup') {
          if(param.selected && param.selected.length > 0){
              filter[param.queryParamString] = param.selected.filter(val => val[param.idLabel])
              .map(val => val[param.idLabel]).join(',');
          }
        } else if(param.type === 'Toggle') {
          if (param.selected) {
            filter[param.queryParamString] = param.selected;
          }
        }
      }
      return filter;
    },

    applyFilters(type) {
      let filterTags = [];
      let error = false;
      if (this.filterConstant && this.filterConstant.length) {
        this.filterConstant.forEach((filterSet,index1) => {
          if (filterSet && filterSet.length) {
            filterSet.forEach((filter,index2) => {
              const checkPermission =
                filter.hasOwnProperty('hasPermission') ? filter.hasPermission: true;
              if(checkPermission) {
                if( ['List','MultiSelectList', 'MultiSelectGroup'].includes(filter.type) ) {
                  filterTags.push(Object.assign({}, filter));
                } else if(filter.type === 'Date') {
                  if(!filter.optional && (!filter.startDate || !filter.endDate)) {
                    this.$errorMessage({message : 'Please select a valid date range'});
                    error = true;
                  } else {
                    filterTags.push(Object.assign({}, filter));
                  }
                } else if(filter.type === 'DatePicker') {
                  if(!filter.optional && (!filter.startDate || !filter.endDate)) {
                    this.$errorMessage({message : 'Please select a valid date range'});
                    error = true;
                  } else {
                    if(!this.selectedDateFilter) {
                      this.selectedDateFilter = filter.dateType || 'creation';
                    }
                    filter.dateType = this.selectedDateFilter;
                    filterTags.push(Object.assign({}, filter));
                  }
                } else if (filter.type === 'SingleDate') {
                  filterTags.push(Object.assign({}, filter));
                } else if (filter.type === 'GroupList') {
                  const filter1 = JSON.parse(JSON.stringify(filter));
                  filterTags.push(filter1);
                } else if (filter.type === 'Toggle') {
                  filterTags.push(Object.assign({}, filter));
                }
              }
            })
          }
        });
      }
      if (!error) {
        const key = type
          ? `${type}-filter`
          : `${this.localStorageTagName}-filter`;

        localStorage.setItem(key, JSON.stringify(this.filterConstant));
        this.filterTags = filterTags;
      }
    },

    loadFilters(preserveSelected = false) {
      const oldFilters = localStorage.getItem(`${this.localStorageTagName}-filter`);
      if (oldFilters && oldFilters.length && !preserveSelected) {
        this.filterConstant = JSON.parse(oldFilters);
      } else {
        const beforeFilters = preserveSelected ? this.filterConstant : [];
        this.constructConstantForFilter();
        if (beforeFilters && beforeFilters.length) {
          beforeFilters.flat().forEach((oldFilter) => {
            this.filterConstant.flat().forEach((newFilter, flatIndex) => {
              if (oldFilter.queryParamString === newFilter.queryParamString) {
                if (oldFilter.selected !== undefined) {
                  this.filterConstant.flat()[flatIndex].selected = oldFilter.selected;
                }
                // NEW: Restore DatePicker fields
                if (newFilter.type === 'DatePicker') {
                  if (oldFilter.startDate) this.filterConstant.flat()[flatIndex].startDate = oldFilter.startDate;
                  if (oldFilter.endDate) this.filterConstant.flat()[flatIndex].endDate = oldFilter.endDate;
                  if (oldFilter.dateType) {
                    this.filterConstant.flat()[flatIndex].dateType = oldFilter.dateType;
                    this.selectedDateFilter = oldFilter.dateType; // critical: restore radio selection
                  }
                }
                // Also restore regular Date type if present
                if (newFilter.type === 'Date') {
                  if (oldFilter.startDate) this.filterConstant.flat()[flatIndex].startDate = oldFilter.startDate;
                  if (oldFilter.endDate) this.filterConstant.flat()[flatIndex].endDate = oldFilter.endDate;
                }

              }
            });
          });
        }
      }
      if(this.hasCustomConstruct) {
        this.customConstructFilter();
      }
    },

    resetField(index1, index2) {
      if(['List','MultiSelectList','MultiSelectGroup'].includes(this.filterConstant[index1][index2].type)) {
        this.filterConstant[index1][index2].selected = this.filterConstant[index1][index2].default;
      } else if( this.filterConstant[index1][index2].type === 'Date') {
        this.filterConstant[index1][index2].startDate =
          this.filterConstant[index1][index2].defaultStartDate;
        this.filterConstant[index1][index2].endDate =
          this.filterConstant[index1][index2].defaultEndDate;
      } else if( this.filterConstant[index1][index2].type === 'DatePicker') {
        this.filterConstant[index1][index2].startDate =
          this.filterConstant[index1][index2].defaultStartDate;
        this.filterConstant[index1][index2].endDate =
          this.filterConstant[index1][index2].defaultEndDate;
      } else if (this.filterConstant[index1][index2].type === 'GroupList') {
        this.filterConstant[index1][index2].selected = this.filterConstant[index1][index2].default;
      }
    },

    resetAll() {
      this.selectedDateFilter = 'creation';
      if(this.hasGACapture) {
        this.callGA('Click', 'Reset All');
      }
      //selected = default
      if (this.filterConstant && this.filterConstant.length) {
        this.filterConstant.forEach((filterSet,index1) => {
          if (filterSet && filterSet.length) {
            filterSet.forEach((filter,index2) => {
              if (this.filterConstant[index1][index2] && this.filterConstant[index1][index2].type) {
                if(
                  ['List','MultiSelectList','MultiSelectGroup'].includes(this.filterConstant[index1][index2].type)
                ) {
                this.filterConstant[index1][index2].selected =
                  this.filterConstant[index1][index2].default;
                } else if( this.filterConstant[index1][index2].type === 'Date') {
                  this.filterConstant[index1][index2].startDate =
                    this.filterConstant[index1][index2].defaultStartDate;
                  this.filterConstant[index1][index2].endDate =
                    this.filterConstant[index1][index2].defaultEndDate;
                } else if( this.filterConstant[index1][index2].type === 'DatePicker') {
                  this.filterConstant[index1][index2].startDate =
                    this.filterConstant[index1][index2].defaultStartDate;
                  this.filterConstant[index1][index2].endDate =
                    this.filterConstant[index1][index2].defaultEndDate;
                } else if( this.filterConstant[index1][index2].type === 'SingleDate') {
                  this.filterConstant[index1][index2].selected = null;
                } else if (this.filterConstant[index1][index2].type === 'GroupList') {
                  this.filterConstant[index1][index2].selected = this.filterConstant[index1][index2].default;
                } else if (this.filterConstant[index1][index2].type === 'Toggle') {
                  this.filterConstant[index1][index2].selected = this.filterConstant[index1][index2].default;
                }
              }
            })
          }
        });
      }
    },

    constructDepotGroup(associatedDepots, otherDepots, selectedDepotIds) {
      const group = [];
      if(associatedDepots && associatedDepots.length) {
          group.push(
              {
              label: 'Associated Depots',
              isSelected: false,
              options: associatedDepots.map((depot) => {
                return Object.assign({}, depot, { isSelected: selectedDepotIds.includes(depot.id) });
              }),
            }
          );
      }
      if(otherDepots && otherDepots.length) {
          group.push({
            label: 'Other Depots',
            isSelected: false,
            options: otherDepots.map((depot) => {
              return Object.assign({}, depot, { isSelected: selectedDepotIds.includes(depot.id) });
            }),
          });
      }
      return group;
    }
  },
};
export default SecFilterMixin;
</script>
